module.exports = __webpack_public_path__ + "img/courier.b647de1b.svg";